import React from 'react'

import styles from './Bridge.module.scss'
import images from 'assets/images'
import { MinusIcon, PlusIcon } from 'lucide-react'
import Faq from 'components/Faq'

const arrBridge = [
  {
    logo: images.bridge1,
    link: 'https://layerzero.network/',
    name: 'LayerZero',
  },
  {
    logo: images.bridge2,
    link: 'https://arken.ag/bridge',
    name: 'Arken',
  },
  {
    logo: images.bridge3,
    link: 'https://hyperlane.xyz/',
    name: 'Hyperlane',
  },
  {
    logo: images.bridge4,
    link: 'https://docs.coin98.com/products/coin98-super-wallet/mobile/spacegate',
    name: 'SpaceGate',
  },
  {
    logo: images.bridge7,
    link: 'https://zeroway.io/',
    name: 'Zeroway',
  },
  {
    logo: images.bridge8,
    link: 'https://app.interport.fi/',
    name: 'Interport',
  },
  {
    logo: images.bridge9,
    link: 'https://l2marathon.com/',
    name: 'L2 Marathon',
  },
]

const arrFaq = [
  {
    id: 'faq1',
    question: 'Is there a transaction limit?',
    answer:
      'Specify any minimum or maximum transfer amounts will be specified within the interface before you initiate a transaction',
  },
  {
    id: 'faq2',
    question:
      'What should I do if I encounter issues using the bridge platform?',
    answer:
      'Please double-check your transaction details and network selection. If the problem continues, reach out to customer support for help.',
  },
  {
    id: 'faq3',
    question: 'Can I transfer stablecoins using token bridges?',
    answer: `Yes, most token bridges support stablecoins like USDT, USDC, and others. Check for the specific ones available on the platform you're using to confirm.`,
  },
]

function BridgeScreen() {
  return (
    <div className={styles.bridgeScreen}>
      <div className='bridge-container'>
        <div className='bridge-banner'>
          <h1 className='bridge-title'>VIC Bridges</h1>
          <div className='bridge-description'>
            Easy bridge from Ethereum, Arbitrum One, BNB Smart Chain, Solana,
            and more to Viction
          </div>

          <img src={images.curveWhiteUp} alt='' className='curve-white' />
        </div>

        <div className='bridge-content-wrapper'>
          <div className='bridge-content-container'>
            <div className='bridge-content'>
              {arrBridge.map((item, index) => {
                return (
                  <a
                    href={item.link}
                    target='_blank'
                    rel='noopener noreferrer'
                    key={index}>
                    <div className='bridge-item'>
                      <div className='bridge-item__logo'>
                        <img src={item.logo} alt='' className='logo-bridge' />
                      </div>

                      <div className='bridge-item__name'>{item.name}</div>
                    </div>
                  </a>
                )
              })}
            </div>

            <div className='bridge-footer'>
              * Disclaimer: All tools interacting with assets are provided by
              partners of Viction and are not directly operated by us. Please
              always double-check the status of the tool and test with a small
              amount before performing large transactions to avoid potential
              loss.
            </div>
          </div>
        </div>

        <Faq arrFaq={arrFaq} />
      </div>
    </div>
  )
}

export default BridgeScreen
